/**
 * @author bucai
 * @email 1450941858@qq.com
 * @create date 2022-10-29 11:10:40
 * @modify date 2022-10-29 11:29:43
 * @desc 做locationId判定
 */
import router from "../../router";
export const cuCodeRex = /^8[0-9]{16}$/;
const handles = [
  {
    math: 1,
    handle() {
      // todo 跳转到称重页面
    },
  },
  {
    math: 2,
    handle() {
      // 跳转到ai后厨
      router.replace("/AI/chref");
    },
  },
  {
    math: /^7[0-9]{15}$/,
    handle() {
      // 处理
    },
  },
];

/**
 * 消费 locationId
 * @param {*} locationId
 * @returns {boolean} 是否消费
 */
export const consume = (locationId) => {
  if (!locationId) return false;
  const handle = handles.find((item) => {
    if (item.math instanceof RegExp) {
      return item.math.test(`${locationId || ""}`);
    } else {
      return `${locationId}` === `${item.math}`;
    }
  });
  if (!handle) return false;
  handle.handle();
  localStorage.removeItem("locationId");
  return true;
};
